"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToAttributeConfiguration = void 0;

var convertToAttributeConfiguration = function convertToAttributeConfiguration(initialSelections) {
  var v2InitialSelections = {};
  initialSelections.forEach(function (attribute) {
    v2InitialSelections[attribute.key] = {
      isHidden: !attribute.isDisplayed,
      initialSelection: attribute.resolvedValue
    };
  });
  return v2InitialSelections;
};

exports.convertToAttributeConfiguration = convertToAttributeConfiguration;